<template>
    <span class="newsLabel"><slot/></span>
</template>

<script>

export default {
    name: "NewsLabel",
    props: {
        cssClass: {
            type: String
        }
    },
    setup(props) {
        return {
            props
        };
    },
};
</script>

<style lang="scss">
@use "../scss/design-library/colors";
@use "../scss/design-library/typography";
@use "../scss/design-library/grid";
@use "sass:map";

.newsLabel {
    @include typography.headline3();
    background-color: #{colors.$button-raised-primary};
    color: #{colors.$white};
    line-height: 1em;
    margin-block: auto;
    font-size: .8em;
    text-align: center;
    padding: 3px 10px;
    border-radius: 9999px;
}
</style>
